"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUserMeasurement = hasUserMeasurement;
exports.isCaptureHidden = isCaptureHidden;
exports.compositeURL = compositeURL;
exports.captureReferenceString = captureReferenceString;
exports.extractSubforms = extractSubforms;
const core_shared_1 = require("@ikegps/core-shared");
const core_shared_2 = require("@ikegps/core-shared");
const core_shared_3 = require("@ikegps/core-shared");
const lodash_1 = require("lodash");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const DataGrid_1 = require("./components/DataGrid");
const ImageGrid_1 = require("./components/ImageGrid");
const SubForm_1 = require("./components/SubForm");
const DataExtractor_1 = require("./DataExtractor");
/**
 * Checks if a poles capture has any user measurements / annotations
 * NOTE: Insight generated measurements are ignored as we don't want them so show up in reports
 * @param pole The pole object.
 * @param captureId The ID of the capture.
 * @returns A boolean indicating whether the capture has user measurements / annotations
 */
function hasUserMeasurement(pole, captureId) {
    return pole.getDrawableState(captureId).hasUserMeasurements();
}
/**
 * Checks if a capture is marked as hidden
 * @param pole The pole object.
 * @param captureId -he ID of the capture.
 * @returns A boolean indicating whether the capture is marked as hidden
 */
function isCaptureHidden(pole, captureId) {
    return pole.getImageVisibilityState(captureId).hideForExport();
}
/**
 * Generates a composite URL for a given pole and capture file
 * @param pole The pole object.
 * @param capture The capture file object.
 * @returns The composite URL.
 */
function compositeURL(pole, capture) {
    const units = services_1.Services.UserSettings.units;
    return `${window.location.origin}/v1/collection/${pole.id}/${pole.revision}/${capture.objectId}_large_composite_${units}.jpeg`;
}
/**
 * Generates an ImageReference string based on the provided pole and capture information.
 * @param pole The pole object.
 * @param capture The capture file JSON object.
 * @returns The generated ImageReference string
 */
function captureReferenceString(pole, capture) {
    return `${pole.revision}-${capture.objectId}`;
}
/**
 * Extracts information from a sub form and returns an array of renderable SubForms.
 * @param subform The sub form to extract data from
 * @param imagesHolder The object to store image URL references
 * @returns An array of renderable SubForms.
 */
function extractSubforms(pole, subform, imagesHolder, columns = DataGrid_1.DEFAULT_COLUMN_AMOUNT) {
    const instanceArray = [];
    (0, lodash_1.forEach)(subform.instances, (instance) => {
        const subfieldsArray = [];
        const subformArray = [];
        const imageGrid = [];
        const truesizeGrid = [];
        instance.forEachField((subfield) => {
            if (subfield.parent.instanceId === instance.instanceId) {
                switch (true) {
                    // Extract all the images and add them to their respective grids
                    case subfield instanceof core_shared_3.CollectionModelFieldImage:
                    case subfield instanceof core_shared_2.CollectionModelFieldTrueSize:
                        const captures = subfield.getCaptures();
                        const targetGrid = subfield instanceof core_shared_2.CollectionModelFieldTrueSize ? truesizeGrid : imageGrid;
                        if (captures.length > 0) {
                            const imageReferences = [];
                            captures.forEach(capture => {
                                if (!isCaptureHidden(subform.collection, capture.objectId)) {
                                    const imageReferenceString = captureReferenceString(pole, capture);
                                    imagesHolder[imageReferenceString] = subfield instanceof core_shared_2.CollectionModelFieldTrueSize ? compositeURL(subform.collection, capture) : capture.medium.url;
                                    imageReferences.push({ reference: imageReferenceString });
                                }
                            });
                            if (imageReferences.length > 0) {
                                targetGrid.push(new ImageGrid_1.ImageGrid({ [subfield.schema.displayName]: imageReferences }));
                            }
                        }
                        break;
                    case subfield instanceof core_shared_1.CollectionModelFieldSubForm:
                        subformArray.push(...extractSubforms(pole, subfield, imagesHolder, columns));
                        break;
                    default:
                        const extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(subfield);
                        if (extractedValue.value) {
                            subfieldsArray.push([extractedValue.title, extractedValue.value]);
                        }
                }
            }
        });
        instanceArray.push(new SubForm_1.SubForm(subform.schema.displayName, instance.title || instance.subtitle || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), [new DataGrid_1.DataGrid(subfieldsArray, columns), ...imageGrid, ...truesizeGrid, ...subformArray]));
    });
    return instanceArray;
}
//# sourceMappingURL=ReportHelpers.js.map